<template>
  <div ref="container" >
    <a-modal :z-index="99" :title="title" width="90%" :visible="visible"
             :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px','bottom':'200px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
      </div>


      <span class="lisenceTitle" >基础信息</span>
      <a-descriptions style="padding: 0px 50px">
        <a-descriptions-item label="单据号">{{detail.billCode}}</a-descriptions-item>
        <a-descriptions-item label="单据描述">{{detail.billRemark}}</a-descriptions-item>
        <a-descriptions-item label="操作人">{{detail.createBy}}</a-descriptions-item>
        <a-descriptions-item label="录入时间">{{detail.recordTime}}</a-descriptions-item>
        <a-descriptions-item label="上传时间">{{detail.createTime}}</a-descriptions-item>
        <a-descriptions-item label="追溯状态">
          <a-tag v-if="detail.regulatoryStatus == 0" color="blue">未上传</a-tag>
          <a-tag v-if="detail.regulatoryStatus == 1" color="green">已上传</a-tag>
          <a-tag v-if="detail.regulatoryStatus == 2" color="orange">上传失败</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="上传追溯时间">{{detail.regulatoryTime}}</a-descriptions-item>
        <a-descriptions-item label="监管状态">
          <a-tag v-if="detail.retroactiveStatus == 0" color="blue">未上传</a-tag>
          <a-tag v-if="detail.retroactiveStatus == 1" color="green">已上传</a-tag>
          <a-tag v-if="detail.retroactiveStatus == 2" color="orange">上传失败</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="上传监管时间">{{detail.retroactiveTime}}</a-descriptions-item>
      </a-descriptions>

      <span class="lisenceTitle" >器械详情</span>
      <div v-for="(item,index) in dataSource">

        <a-descriptions style="padding: 0px 50px">
          <a-descriptions-item label="器械名称">{{item.hilistName}}</a-descriptions-item>
          <a-descriptions-item label="医保编码">{{item.hilistCode}}</a-descriptions-item>
          <a-descriptions-item label="品类码">{{item.categoryCode}}</a-descriptions-item>
          <a-descriptions-item label="规格">{{item.regSpec}}</a-descriptions-item>
          <a-descriptions-item label="包装单位">{{item.pacunt}}</a-descriptions-item>
          <a-descriptions-item label="企业名称">{{item.enterprise}}</a-descriptions-item>
        </a-descriptions>
        <a-table :columns="[{
          title: '追溯码',
          dataIndex: 'traceCode',
          key: 'traceCode',
        }]" :data-source="item.traceCodeList" bordered :pagination="false" style="padding: 0px 50px">
        </a-table>
        <hr style="border:1px solid #eeeeee;margin: 20px" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { findBillDetailByNumber, instrumentTrace } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JEllipsis,
  },
  data() {
    return {
      detail:{},
      loading: false,
      title: '操作',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      // 表头
      columns: [
        {
          "title": "产品名称",
          "dataIndex": "materialName"
        },
        { title: 'DI信息', dataIndex: 'di', width: 100 },
        {
          "title": "批次",
          "dataIndex": "batchNumber"
        },
        {
          "title": "包装详情",
          "dataIndex": "details",
          align: 'center',
        },

        {
          "title": "规格",
          "dataIndex": "standard"
        },

        {
          "title": "包装规格",
          "dataIndex": "packSpec",
          width: 100, scopedSlots: { customRender: 'packSpec' }
        },
        {
          "title": "采集日期",
          "dataIndex": "createTime",
          scopedSlots: { customRender: 'createTime' }
        },
        {
          "title": "状态",
          "dataIndex": "status",
          align: 'center', width: 40, scopedSlots: { customRender: 'status' }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
    }
  },
  created() {},
  methods: {
    async show(e) {

      this.detail = e

      this.visible = true

      const res = await instrumentTrace({ infoId:e.id})

      this.dataSource = res.result

      console.log(res,'res')

    },
    codeDetail(record){

    },
    close() {
      this.$emit('close')
      this.visible = false
      if (!this.uuid) {
        this.$emit('fatherMethod')
      }
    },
    handleCancel() {
      this.close()
    },

    myHandleDetail(record) {
      let that = this
      this.toFromType = record.fromType
      findBillDetailByNumber({ number: record.number }).then((res) => {
        if (res && res.code === 200) {
          this.$refs.billDetail.isCanBackCheck = false
          that.$refs.billDetail.show(res.data, record.type)
          that.$refs.billDetail.title = '详情'
        }
      })
    },

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.lisenceTitle {
  display: block;
  font-size: 16x;
  margin: 30px 0 30px;
  padding-left: 10px;
  border-left: 4px solid #1890FF;
}
</style>
<style>
.ant-modal-content{
  margin-bottom: 200px;
}
</style>